import { Injectable } from "@angular/core";
import { NotifierService } from "src/app/_services/notifier.service";
import { WeeklyPaginatedService } from "./chargesbyservice/service-charges.model";

export interface AnyObject {
  [key: string]: any;
  expanded?: boolean;
}

@Injectable({
  providedIn: "root",
})
export class MonthlyExpandService {
  public isExpandedAll = false;
  public services: any[] = [];

  constructor(private notifier: NotifierService) {}

  /**
   * Recursively add 'expanded: false' flag to all non-empty objects/arrays
   * Skips empty objects {} and empty arrays []
   */
  public addExpandedFlag(data: any): any {
    if (Array.isArray(data)) {
      if (data.length === 0) {
        console.log("addExpandedFlag -> Skipping empty array:", data);
        return data;
      }
      console.log("addExpandedFlag -> Processing array:", data);
      return data.map(item => this.addExpandedFlag(item));
    } else if (data && typeof data === "object") {
      if (Object.keys(data).length === 0) {
        console.log("addExpandedFlag -> Skipping empty object:", data);
        return data;
      }
      const newData = { ...data, expanded: false };
      console.log("addExpandedFlag -> Adding expanded flag to object:", newData);

      for (const key of Object.keys(newData)) {
        if (Array.isArray(newData[key]) || (newData[key] && typeof newData[key] === "object")) {
          console.log(`addExpandedFlag -> Recursing into key: ${key}`);
          newData[key] = this.addExpandedFlag(newData[key]);
        }
      }

      return newData;
    }

    console.log("addExpandedFlag -> Primitive value, returning as-is:", data);
    return data; // primitive value
  }
public toggleExpandRecursive(obj: any, expandAll: boolean): void {
  if (Array.isArray(obj)) {
    obj.forEach(item => this.toggleExpandRecursive(item, expandAll));
  } else if (obj && typeof obj === 'object' && Object.keys(obj).length) {
    obj.expanded = expandAll;
    console.log("Setting expanded =", expandAll, "for object:", obj);

    Object.keys(obj).forEach(key => {
      if (obj[key] && typeof obj[key] === 'object') {
        if (!Array.isArray(obj[key])) {
          obj[key] = Object.values(obj[key]); // normalize object to array
        }
        this.toggleExpandRecursive(obj[key], expandAll);
      }
    });
  }
}

public toggleWeeklyExpand(
  services: WeeklyPaginatedService[],
  expandAll: boolean
): void {
  console.log("toggleWeeklyExpand called with expandAll =", expandAll);

  services.forEach(service => {
    service.expanded = expandAll;
    console.log(`Service '${service.service_name}' expanded =`, service.expanded);

    service.regions.forEach((region: any) => {
      region.expanded = expandAll;
      console.log(`  Region '${region.region}' expanded =`, region.expanded);

      region.product_families.forEach((pf: any) => {
        // optionally, add expanded flag for product families
        console.log(`    Product Family '${pf.name}' processed`);
      });
    });
  });

  console.log("Final services state after toggle:", services);
}

paginate<T>(list: T[], page: number, pageSize: number): T[] {
    const start = (page - 1) * pageSize;
    return list.slice(start, start + pageSize);
  }

  totalPages(list: any[], pageSize: number): number {
    return Math.ceil(list.length / pageSize);
  }

  nextPage(current: number, total: number): number {
    return current < total ? current + 1 : current;
  }

  prevPage(current: number): number {
    return current > 1 ? current - 1 : current;
  }

}


